import lazy from './lib/_lazy-load';
// import $ from 'jquery';

//
//  Custom JS Theme
//

import lazyLoad from './lib/_lazy-load'
import aos from './lib/_aos'
import charts from './lib/_charts'

import slider from './widget/_slider'
import gallery from './widget/_gallery'
import modal from './widget/_modal'
import modalWithContent from './widget/_modal-with-content'
import counter from './widget/_counter'
import './widget/_video-modal'
import './widget/_lang-redirect'

import './our-history/_our-history'
import scrolldown from './misc/_scrolldown'

import textToggle from './misc/_text-toggle'
import splitScroller from './misc/_split-scroller'
import countriesDatalist from './misc/_countries-datalist'
